import metric_message from "@/domain/metrics/message";

const state = {
    picaServiceId: null,
}

const getters = {
    picaServiceId: (state) => state.picaServiceId,
}

const mutations = {
    SET_PICASERVICE_ID(state, picaServiceId) {
        state.picaServiceId = picaServiceId
        metric_message.setEventId(picaServiceId)
    },
    UNSET_PICASERVICE_ID(state) {
        state.picaServiceId = null
        metric_message.setEventId(null)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
